export default __webpack_public_path__ + "static/media/SavedContract.5d48ccec.png";